import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// ============================================
// タブ
// ============================================
function tabFunc() {
  const tabList = document.querySelector('.js-tab__trigger');
  const tabs = document.querySelectorAll('.js-tab__trigger-item');
  const contents = document.querySelectorAll('.js-tab__content-item');

  //タブを切り替える関数
  // ===========================
  function switchTabs() {
    flowNavAnim();
    // タブクリック
    tabs.forEach((target) => {
      target.addEventListener('click', (e) => {
        const targetNav = e.target.getAttribute('aria-controls');
        if (target.ariaSelected === 'false') {
          //タブ選択解除
          tabs.forEach((tab) => {
            tab.ariaSelected = false;
            tab.setAttribute('tabindex', -1);
          });

          toggleContent(target);

          //タブをアクティブに
          target.ariaSelected = true;
          target.setAttribute('tabindex', 0);
          target.focus();
        }
        flowNavAnim(targetNav);
      });
    });
  }
  //コンテンツ表示・非表示
  // ==========================
  function toggleContent(target) {
    contents.forEach((item) => {
      if (item.id !== target.getAttribute('aria-controls')) {
        item.style.display = 'none';
      } else {
        item.style.display = 'revert';
      }
    });
  }

  // タブ矢印キーでの操作
  // ==========================
  function changeTabs() {
    let tabFocus = 0;
    tabList.addEventListener('keydown', (e) => {
      if (e.keyCode === 37 || e.keyCode === 39) {
        tabs[tabFocus].ariaSelected = false;
        tabs[tabFocus].setAttribute('tabindex', -1);

        //戻るボタン
        if (e.keyCode === 37) {
          tabFocus--;
          if (tabFocus < 0) {
            tabFocus = tabs.length - 1;
          }
        } else if (e.keyCode === 39) {
          // 進むボタン
          tabFocus++;
          if (tabFocus >= tabs.length) {
            tabFocus = 0;
          }
        }

        tabs[tabFocus].ariaSelected = true;
        tabs[tabFocus].setAttribute('tabindex', 0);
        toggleContent(tabs[tabFocus]);
        tabs[tabFocus].focus();
      }
    });
  }

  // Flowページ用 追従ナビアニメーション
  // ==========================
  function flowNavAnim(targetSectionId) {
    if (window.innerWidth <= 1024) return;

    const flowPage = document.getElementById('flow');
    if (!flowPage) return;

    let targetSelector = '.c-sidenav__link';
    if (targetSectionId) {
      targetSelector = '#' + targetSectionId + ' .c-sidenav__link';
    }

    const targets = document.querySelectorAll(targetSelector);
    const targetArray = [];
    let num = 0;
    targets.forEach((target) => {
      const targetId = target.href.split('#')[1];
      targetArray[num] = document.getElementById(targetId);
      num++;
    });

    targetArray.forEach((target, index) => {
      ScrollTrigger.create({
        trigger: target,
        start: () => 'top 50%',
        end: () => 'bottom 50%',
        onEnter: () => {
          addClass(targets[index]);
        },
        onLeaveBack: () => {
          addClass(targets[index - 1]);
        },
      });
    });

    //is-activeを全部外してtargetにつける関数
    function addClass(htmlDom) {
      if (!htmlDom) return;
      targets.forEach((target) => {
        if (target.classList.contains('is-active')) {
          target.classList.remove('is-active');
        }
      });
      htmlDom.classList.add('is-active');
    }
  }

  //関数の実行
  if (tabList && tabs && contents) {
    switchTabs();
    changeTabs();
  }
}

export { tabFunc };
